module.exports = __webpack_public_path__ + "static/media/carrot-logo-mark-white.f5121e92.png";